import { Base } from "./Base";
import { throwExpected, SpaceNotFoundException, PastExpiryException, UserAlreadyExistsException, PendingInvitationException, EmailMissingException, ForbiddenException, InvalidEmailDomainException, NotFoundException, } from "./exceptions";
export const invitationEntityKinds = ["directInvite", "emailInvite", "weblinkInvite"];
/**
 *
 * The class for consuming all `invitation` resources.
 *
 * @remarks
 * This class should be generated using OpenAPI generator in the future.
 *
 * @alpha
 */
class InvitationService extends Base {
    /**
     * Get invitation by id
     */
    async getOne({ id, queryString }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/invitations/${id}${queryString ? `?${queryString}` : ""}`;
        const json = await throwExpected(async () => fetch.get(url), {
            404: () => new NotFoundException(),
        });
        return json;
    }
    /**
     * Get invitation by key
     */
    async getOneByKey({ key }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/invitations/by-key/${key}`;
        const json = await throwExpected(async () => fetch.get(url), {
            404: () => new NotFoundException(),
        });
        return json;
    }
    /**
     * Get invitations
     */
    async getMany() {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/invitations`;
        const json = await fetch.get(url);
        return json;
    }
    /**
     * Create one invitation
     */
    async createOne(invitation) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/invitations`;
        const json = await throwExpected(async () => fetch.post(url, invitation), {
            404: () => new SpaceNotFoundException(`id: ${invitation.spaceId}`),
            422(e) {
                var _a;
                const msg = (_a = e === null || e === void 0 ? void 0 : e.body.message) !== null && _a !== void 0 ? _a : "";
                if (msg.includes("is already in space")) {
                    return new UserAlreadyExistsException(invitation.invitedUsername);
                }
                if (msg.includes("pending invitation")) {
                    return new PendingInvitationException(invitation.invitedUsername);
                }
                if (msg.includes("email missing")) {
                    return new EmailMissingException();
                }
                return new PastExpiryException();
            },
        });
        return json;
    }
    /**
     * Update one invitation
     */
    async updateOne(invitation) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/invitations/${invitation.id}`;
        const json = await throwExpected(async () => fetch.patch(url, invitation), {
            403(error) {
                var _a, _b, _c;
                const message = (_a = error === null || error === void 0 ? void 0 : error.body) === null || _a === void 0 ? void 0 : _a.message;
                if (typeof message === "string" && message.includes("your email address domain")) {
                    return new InvalidEmailDomainException((_b = error === null || error === void 0 ? void 0 : error.body) === null || _b === void 0 ? void 0 : _b.message);
                }
                return new ForbiddenException((_c = error === null || error === void 0 ? void 0 : error.body) === null || _c === void 0 ? void 0 : _c.message);
            },
        });
        return json;
    }
}
export { InvitationService };
